import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared/shared.module';
import { PostingItemComponent } from './posting-item/posting-item.component';
import { ServiceItemContainerComponent } from './service-item-container/service-item-container.component';
import { ServiceItemHistoryComponent } from './service-item-history/service-item-history.component';
import { ServiceItemRoute } from './service-item.route';
import { ServiceItemComponent } from './service-item/service-item.component';
import { ServiceItemEffects } from './store/service-item.effects';
import * as fromServiceItem from './store/service-item.reducer';
import { SyncDialogContainerComponent } from './sync-dialog/sync-dialog-container/sync-dialog-container.component';
import { SyncDialogPresenterComponent } from './sync-dialog/sync-dialog-presenter/sync-dialog-presenter.component';

@NgModule({
    declarations: [
        ServiceItemComponent,
        ServiceItemContainerComponent,
        PostingItemComponent,
        ServiceItemHistoryComponent,
        SyncDialogContainerComponent,
        SyncDialogPresenterComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(
            fromServiceItem.serviceItemsFeatureKey,
            fromServiceItem.reducer
        ),
        EffectsModule.forFeature([ServiceItemEffects]),
        UIRouterModule.forChild({
            states: [ServiceItemRoute]
        })
    ]
})
export class ServiceItemModule {}
